import { render } from "./TodoView.vue?vue&type=template&id=331eb60d&scoped=true"
import script from "./TodoView.vue?vue&type=script&lang=js"
export * from "./TodoView.vue?vue&type=script&lang=js"

import "./TodoView.vue?vue&type=style&index=0&id=331eb60d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-331eb60d"]])

export default __exports__